module.exports = __webpack_public_path__ + "translations/92c8f4157a0e9773ae41912fa23e4e4f.json";